import { Injectable, HostListener, Directive } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';

@Directive()
@Injectable({
    providedIn: 'root'
})
export class SystemService {


    private readonly _innerWidth = new BehaviorSubject<string>('expanded');
    public innerWidth$ = this._innerWidth.asObservable();

    public staticJson: any = {};

    constructor(private http: HttpClient) {
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this._innerWidth.next('collapsed');
    }

    getPlaces(): Observable<any> {
        return this.http.get('/assets/json/ppcmb.json');
    }

    getCountries(): Observable<any> {
        return this.http.get('/assets/json/cc.json');
    }

    getColors() {
        return [
            '#6610f2', //indigo
            '#007bff', //blue
            '#dc3545', //red
            '#28a745', //green
            '#ffc107', //yellow
            '#17a2b8', //cyan
            '#fd7e14', //orange
            '#6c757d', //gray
            '#20c997', //teal
            '#343a40', //gray_dark
            '#DC143C', //crimson
            '#FFA07A', //light salmon
            '#FFD700', //gold
            '#FF00FF', //fuchsia
            '#2E8B57', //seagreen
            '#B0C4DE', //light steel blue
            '#009DA0', //primary
            '#868e96', //secondary
            '#0CC27E', //success
            '#1CBCD8', //info
            '#FF8D60', //warning
            '#FF586B', //danger
            '#f8f9fa', //light
            '#343a40', //dark
        ];
    }

}
